/*eslint-disable */
import React, { Component } from "react";
import { Table, Grid, Icon, Button } from "semantic-ui-react";
import RateChartModal from "./rateChartModal";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import Name from "./name";
import { translate } from "react-i18next";
import DeleteModal from "../common/deleteModal";
import VendorVehicleEdit from "../common/vendorVehicleEdit";
import VehicleDetailModal from "./vehicleDetailModal";
import DeleteAxios from "../axiosComponent/delete";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
export class VendorVehicleTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendorRateChart: [],
      deleteModalOpen: false,
      vendorvehicle: false,
      edit: {},
    };
  }

  componentDidMount() {
    this.setState({
      vendorvehicle: false
    })
    // this.getVendorRateChart();
  }

  setDeafultValue = (masterRoute, deafultValue) => {
    console.log("search dropdown >>>>", deafultValue);
    ReadAxios({
      url: `${masterRoute}/${deafultValue}`,
    })
      .then((res) => {
        console.log(res.data.resultSet);
      })
      .catch((err) => console.log(err));
  };

  VendorVehicleEditModal = () => {
      this.setState({
        vendorvehicle: true
      })
  };

  VendorVehicleEditModalClose = () => {
    this.setState({ vendorvehicle: false });
  };

  openDeleteModal = (rateChart = {}) => {
    this.setState({ deleteModalOpen: true, edit: rateChart });
  };

  closeDeleteModal = () => {
    this.setState({ deleteModalOpen: false });
  };

  editVehicleModal = (e, data) => {
    console.log(data);
    if (data.add_mode === 'add') {
      this.setState({
        vendorvehicle: true,
        editUserInputs: false,
        edit: null,
      })
    } else if (data.add_mode === 'edit') {
      this.setState({
        vendorvehicle: true,
        editUserInputs: true,
        edit: { ...data.user_items },
      })
    } else {
      this.setState({
        deleteModalOpen: true,
        edit: { ...data.user_items },
      })
    }
  };

  confirmDelete = () => {
    console.log("delete row");
    DeleteAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/rate/${this.state.edit.vendor_rate_id}`,
    })
      .then((res) => {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: "Vendor rate deleted.",
        };
        console.log(res);
        this.props.successAlertDispatcher(alert);
        this.closeDeleteModal();
        this.getVendorRateChart();
      })
      .catch((err) => {
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: "Unable to delete vendor rate.",
        };
        console.log(err);
        this.props.errorAlertDispatcher(alert);
        this.closeDeleteModal();
      });
  };

  updatePage = () => {
    console.log('this is called');
    this.VendorVehicleEditModalClose();
    window.location.reload();
  };

  render() {
    const { t } = this.props;
    return (
      <>
        {true && (
          <div>
            <Table stackable size="small" selectable>
              <Table.Header className="w3-small">
                <Table.Row>
                  <Table.HeaderCell colSpan="3" className="p-bold-600">
                    {t('title')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-600" textAlign="right">
                    <Button
                      type="button"
                      className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                      add_mode="add"
                      onClick={this.editVehicleModal}
                    >
                      <Icon name="plus" /> {t('add_title')}
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.vehicle_no")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.vehicle_type")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.vehicle_ownership")}
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell className="p-bold-500">
                    {t("table_header.vehicle_load_capacity")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.gps_vendor")}
                  </Table.HeaderCell> */}
                  {/* <Table.HeaderCell className="p-bold-500">
                    {t("table_header.base_location")}
                  </Table.HeaderCell> */}
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.more_detail")}
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell className="p-bold-500">
                    {t('table_header.edit') || 'Edit'}
                </Table.HeaderCell>
                <Table.HeaderCell className="p-bold-500">
                    {t('table_header.delete') || 'Delete'}
                </Table.HeaderCell> */}
                </Table.Row>
              </Table.Header>
              <Table.Body>
            {this.props.vehicleList && this.props.vehicleList.length > 0 ? (
              this.props.vehicleList.map((object, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{object.vehicleNumber ? object.vehicleNumber : "NA"}</Table.Cell>
                  <Table.Cell>{object.vehicleType ? object.vehicleType : "NA"}</Table.Cell>
                  <Table.Cell>{object.vehicleOwner ? object.vehicleOwner : "NA"}</Table.Cell>
                  {/* <Table.Cell>{object.vehicleLOadCapacity ? object.vehicleLOadCapacity : "NA"}</Table.Cell> */}
                  {/* <Table.Cell>{object.vehicleGps ? object.vehicleGps : "NA"}</Table.Cell> */}
                  {/* <Table.Cell>{object.vehicleBaseLocation ? object.vehicleBaseLocation : "NA"}</Table.Cell> */}
                   <Table.Cell><VehicleDetailModal id={object.vehicleId} data={object}/></Table.Cell>
                  {/* <Table.Cell><Button user_items={object} type="button" add_mode="edit" onClick={this.editVehicleModal} size="mini" color="green" basic icon> <Icon name="edit" /> </Button> </Table.Cell> */}
                  {/* <Table.Cell><Button type="button" user_items={object} add_mode="delete" onClick={this.editUserModal} size="mini" color="blue" basic icon> <Icon name="trash" /> </Button></Table.Cell>  */}
                </Table.Row>
              ))
            ) : (
                <Table.Row>
                  <Table.Cell colSpan="6">{t("records" || "No Record(s) Found")}</Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
            </Table>
          </div>
        )}
        <DeleteModal
          deleteOpen={this.state.deleteModalOpen}
          CloseModal={this.closeDeleteModal}
          ConfirmDeleteRow={this.confirmDelete}
        />
        <VendorVehicleEdit
          vendorId={this.props.vendorId}
          vehicleModal={this.state.vendorvehicle}
          CloseModal={this.VendorVehicleEditModalClose}
          vendor_code={this.props.vendor_code}
          editData={this.state.edit}
          onFormSubmit={this.updatePage}
        />
      </>
    );
  }
}

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate('vehicle')(VendorVehicleTable));
